import { forwardRef, FunctionComponent, useContext, useState } from 'react';
import { IInstitution, ITrial, SourceDataVerificationPatient } from '@/api/dtos';
import { ListItemButton, ListItemText, Chip, Box, LinearProgress, styled, Divider, alpha, Snackbar, ListItem, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, Button, DialogActions, Slide } from '@mui/material'
import { Link } from 'react-router-dom';
import { IPatientDataConfiguration } from '@/utilities/data/PatientDataListProcessor';
import { BasicAlert, FormsFeatureContext } from '@ngt/forms';
import { PostCreateSourceDataByTrialCodeAndPatientStudyNumber } from '../../../../api/dtos';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-duotone-svg-icons';
import { TransitionProps } from '@mui/material/transitions';
import { LoadingButton } from '@mui/lab';


const Container = styled(Box)(({ theme }: any) => ({
    background: theme.palette.background.paper,
    backgroundImage: theme.palette.mode === 'dark' ? 
        `linear-gradient(${alpha(theme.palette.common.white, 0.05)}, ${alpha(theme.palette.common.white, 0.05)})` :
        undefined,
    marginTop: -1
}));

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

interface IPatientDataListConfiguration extends IPatientDataConfiguration {
    trial?: ITrial;
    patient?: SourceDataVerificationPatient;
}

const PatientDataListConfiguration: FunctionComponent<IPatientDataListConfiguration> = ({
    patient,
    trial,
    configuration
}) => {
    return (
        <Container>
            <Divider />
            <ListItem
                disablePadding
            >
                <ListItemButton  component={Link} to={`/${trial?.code}/participants/${patient?.studyNumber}/data/${(configuration ? configuration?.id : 'all')}/real-time`}>
                    <ListItemText
                        primary={configuration ? configuration?.name : 'All Participant Data'}
                        secondary={configuration?.description}
                    />
                </ListItemButton>
            </ListItem>
            <Divider />
        </Container>
    );
}

export default PatientDataListConfiguration;